import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import './case-history.scss'
import { Trans, useTranslation } from "react-i18next";
interface CaseHistoryProps {
  data: Array<{ CreatedDate: string; Description: string }>;
}

const CaseHistory: React.FC<CaseHistoryProps> = ({ data }) => {
const {t} = useTranslation();
  return (
    <>
      <div className="case-history">
        <Container className="container-custom">
          {data.map((history, index) => (
            <Col md={12} className="container-row" key={index}>
              <Row>
                <Col md={2}><label>{t("HPI.EditCase.Case.Date/time",{defaultValue:'Date/time:'})}</label> </Col>
                <Col>{history.CreatedDate}</Col>
              </Row>
              <Row>
                <Col md={2}><label>{t("HPI.EditCase.Case.steps",{defaultValue:'Steps:'})}</label></Col>
                <Col><pre style={{fontFamily: '"Forma DJR UI", Arial, sans-serif',whiteSpace: 'pre-wrap',fontSize: '1rem'}} dangerouslySetInnerHTML={{__html:history.Description}}></pre></Col>
              </Row>
            </Col>
          ))}
        </Container>
      </div>

    </>
  );
};

export default CaseHistory;
